module.exports = __webpack_public_path__ + "images/solcubephone-6242329672ac5d910bfb83d7ce7c2b00.png";